<template>
  <div class="animated fadeIn">
    <b-row>
      <!-- LEFT COLUMN: TARGET LIST -->
      <b-col md="8">
        <b-card>
          <template #header>
            <i class="fa fa-users"></i> <strong>Target List</strong>
          </template>
          
          <b-form-group
            label="Enter targets (one per line)"
            label-for="textarea-input"
            :description="descriptionText"
          >
            <b-form-textarea
              id="textarea-input"
              v-model="text"
              rows="15"
              :placeholder="placeholderText"
              no-resize
            ></b-form-textarea>
          </b-form-group>
        </b-card>
      </b-col>

      <!-- RIGHT COLUMN: CONFIGURATION -->
      <b-col md="4">
        <b-card>
          <template #header>
            <i class="fa fa-cogs"></i> <strong>Configuration</strong>
          </template>

          <b-form-group label="Ban Reason" label-for="ban-reason">
            <b-input-group>
              <b-input-group-prepend is-text>
                <i class="fa fa-comment"></i>
              </b-input-group-prepend>
              <b-form-input 
                id="ban-reason"
                v-model="reason" 
                placeholder="Reason..." 
              />
            </b-input-group>
          </b-form-group>

          <b-form-group label="Identifier Type">
            <b-input-group>
               <b-input-group-prepend is-text>
                <i class="fa fa-tag"></i>
              </b-input-group-prepend>
              <b-form-select v-model="selectBan">
                <option value="username" v-if="hasPermission(MassbanUsers)">Username</option>
                <option value="email" v-if="hasPermission(MassbanEMails)">Email</option>
              </b-form-select>
            </b-input-group>
          </b-form-group>

          <hr>

          <b-alert show variant="warning" class="small">
            <i class="fa fa-exclamation-triangle"></i> <strong>Warning:</strong> Use with caution. Bans are applied to <strong>all servers</strong> immediately.
          </b-alert>

          <b-button 
            block 
            variant="danger" 
            @click="banButton" 
            :disabled="loading || text.length === 0 || selectBan === ''"
          >
            <i class="fa fa-ban"></i> Execute Mass Ban
          </b-button>

        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import VueNotifications from 'vue-notifications'

  export default {
    name: 'Massban',
    data () {
      return {
        loading: false,
        text: '',
        selectBan: 'username',
        reason: '',
      }
    },
    computed: {
      ...mapGetters({
        error: 'systemBanError'
      }),
      descriptionText () {
        return this.selectBan === 'email' 
          ? 'Enter one e-mail address per line.' 
          : 'Enter one username per line.'
      },
      placeholderText () {
        if (this.selectBan === 'email') {
          return 'example1@email.com\nexample2@email.com\nexample3@email.com'
        }
        return 'Player1\nPlayer2\nPlayer3'
      }
    },
    methods: {
      ...mapActions(['clearAuditlog']),
      validateEmail (email) {
        let re = /\S+@\S+\.\S+/
        return re.test(String(email).toLowerCase())
      },
      isAlphaNumeric (str) {
        let code, i, len
        for (i = 0, len = str.length; i < len; i++) {
          code = str.charCodeAt(i)
          if (!(code > 47 && code < 58) && // numeric (0-9)
            !(code > 64 && code < 91) && // upper alpha (A-Z)
            !(code > 96 && code < 123) && // lower alpha (a-z)
            code !== 45 && // hyphen (-)
            code !== 95) { // underscore (_)
            return false
          }
        }
        return true
      },
      banButton () {
        let lines = this.text.split('\n')
        let objects = []
        for (let i in lines) {
          let line = lines[i].trim()
          if (line) {
            if (this.selectBan === 'email' && !this.validateEmail(line)) {
              this.InvalidEmails()
              return
            } else if (this.selectBan === 'username' && !this.isAlphaNumeric(line)) {
              this.InvalidUsernames()
              return
            }
            objects.push(line)
          }
        }
        
        if (objects.length === 0) return;

        if (objects.length > 5) {
          this.ChangeInfo()
        }
        this.loading = true
        const allServers = ['gold', 'silver', 'red', 'blue'];
        this.emit('massBan', {'type': this.selectBan, 'servers': allServers, 'values': objects, 'reason': this.reason})
      }
    },
    notifications: {
      ChangeSuccessful: {
        type: VueNotifications.types.success,
        title: 'Mass ban was successful!',
        message: 'Mass ban was successful!'
      },
      InvalidEmails: {
        type: VueNotifications.types.error,
        title: 'Mass ban failed!',
        message: 'Your E-Mails are invalid, please enter valid E-Mails!'
      },
      InvalidUsernames: {
        type: VueNotifications.types.error,
        title: 'Mass ban failed!',
        message: 'Your Usernames are invalid, please enter valid Usernames!'
      },
      ChangeInfo: {
        type: VueNotifications.types.info,
        title: 'Processing...',
        message: 'This may take several seconds, please be patient.'
      }
    },
    watch: {
      error: function (val) {
        let notFound = []
        let error = val.error
        let count = 0
        for (let i in error) {
          if (error[i] === 3) {
            notFound.push(i)
          } else {
            count++
          }
        }
        this.text = ''
        if (notFound.length > 0) {
          this.text += 'Following ' + (this.selectBan === 'email' ? 'email(s)' : 'user(s)') + ' don\'t exist or failed to ban:\n' + notFound.join('\n') + '\n\n'
        }
        this.text += 'Successfully processed ' + count + ' ' + (this.selectBan === 'email' ? 'emails' : 'users') + '.'
        this.loading = false
      }
    }
  }
</script>
